import styled from 'styled-components';
import {
  Input as SemanticInput,
  Checkbox as SemanticCheckbox,
  Modal as SemanticModal,
} from 'semantic-ui-react';

import { Button as ButtonLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Button = styled(ButtonLayoutComponent)``;

const Input = styled(SemanticInput)`
  width: 90%;
`;

export const InputCheckbox = styled(SemanticCheckbox)`

`;

const ContentRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

const ContainerInput = styled.div`
  display: inline-flex;
  justify-content: flex-end;
  gap: 5%;
`;

const ContainerText = styled.div`
  flex-grow: 1;

`;

const Modal = styled(SemanticModal)``;

const Content = styled(SemanticModal.Content)`
  &&& {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
`;

const Actions = styled(SemanticModal.Actions)``;

const ErrorMessage = styled(TextLayoutComponent)`
  color: red;
`;

export {
  Button,
  Input,
  ContainerInput,
  ContainerText,
  Modal,
  Content,
  ContentRow,
  Actions,
  ErrorMessage,
};
